import React, { useState } from 'react';
import {
  PlayCircle,
  StopCircle,
  Eye,
  Plus,
  CalendarDays,
  ListChecks,
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import EditScheduleModal from '../configurations/ingestion/EditScheduleModal';
import LogsModal from './LogsModal';

const workflows = [
  {
    id: 'wf001',
    name: 'Credit Decision Workflow',
    status: 'Running',
    createdBy: 'admin@agentic.ai',
    createdOn: '2025-05-01',
    trigger: 'API',
    llm: 'LLama',
  },
  {
    id: 'wf002',
    name: 'HR Automation',
    status: 'Stopped',
    createdBy: 'hr@agentic.ai',
    createdOn: '2025-04-28',
    trigger: 'Schedule',
    llm: 'ChatGPT-4',
  },
  {
    id: 'wf003',
    name: 'Invoice Reconciliation Flow',
    status: 'Running',
    createdBy: 'finance@agentic.ai',
    createdOn: '2025-04-20',
    trigger: 'Webhook',
    llm: 'Gemini Pro',
  },
  {
    id: 'wf004',
    name: 'Customer Support Triage',
    status: 'Running',
    createdBy: 'support@agentic.ai',
    createdOn: '2025-04-18',
    trigger: 'Chat',
    llm: 'ChatGPT-4',
  },
  {
    id: 'wf005',
    name: 'Incident Alert Dispatcher',
    status: 'Stopped',
    createdBy: 'ops@agentic.ai',
    createdOn: '2025-04-10',
    trigger: 'Email',
    llm: 'Claude 3',
  },
  {
    id: 'wf006',
    name: 'Warehouse Stock Notifier',
    status: 'Running',
    createdBy: 'logistics@agentic.ai',
    createdOn: '2025-03-30',
    trigger: 'Database Poll',
    llm: 'Gemini Nano',
  },
  {
    id: 'wf007',
    name: 'Daily Compliance Reporter',
    status: 'Running',
    createdBy: 'compliance@agentic.ai',
    createdOn: '2025-03-27',
    trigger: 'Schedule',
    llm: 'ChatGPT-4',
  },
  {
    id: 'wf008',
    name: 'Legal Contract Review Assistant',
    status: 'Stopped',
    createdBy: 'legal@agentic.ai',
    createdOn: '2025-03-15',
    trigger: 'API',
    llm: 'LLaMA 3',
  },
  {
    id: 'wf009',
    name: 'Marketing Campaign Reviewer',
    status: 'Running',
    createdBy: 'marketing@agentic.ai',
    createdOn: '2025-03-10',
    trigger: 'Form Submission',
    llm: 'Claude 3',
  },
  {
    id: 'wf010',
    name: 'Expense Approval Assistant',
    status: 'Stopped',
    createdBy: 'finance@agentic.ai',
    createdOn: '2025-02-28',
    trigger: 'Chat',
    llm: 'ChatGPT-4',
  },
  {
    id: 'wf011',
    name: 'IT Asset Tracker',
    status: 'Running',
    createdBy: 'it@agentic.ai',
    createdOn: '2025-02-20',
    trigger: 'Webhook',
    llm: 'Gemini Pro',
  },
  {
    id: 'wf012',
    name: 'Clinical Trial Data Extractor',
    status: 'Running',
    createdBy: 'med@agentic.ai',
    createdOn: '2025-02-10',
    trigger: 'Schedule',
    llm: 'Claude 3',
  },
  {
    id: 'wf013',
    name: 'Real Estate Portfolio Tracker',
    status: 'Stopped',
    createdBy: 'property@agentic.ai',
    createdOn: '2025-01-30',
    trigger: 'API',
    llm: 'LLaMA 3',
  },
  {
    id: 'wf014',
    name: 'Student Feedback Analyzer',
    status: 'Running',
    createdBy: 'education@agentic.ai',
    createdOn: '2025-01-15',
    trigger: 'Form Submission',
    llm: 'Gemini Nano',
  },
  {
    id: 'wf015',
    name: 'Sales Performance Forecaster',
    status: 'Running',
    createdBy: 'sales@agentic.ai',
    createdOn: '2025-01-01',
    trigger: 'Schedule',
    llm: 'ChatGPT-4',
  },
];


const Workflows = () => {
  const [nameFilter, setNameFilter] = useState('');

  const filtered = workflows.filter((wf) =>
    wf.name.toLowerCase().includes(nameFilter.toLowerCase())
  );
  const navigate = useNavigate();

  const NavigateToBuilder = () => {
    navigate('/portal/flowbuilder')
  }
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [selectedWorkflow, setSelectedWorkflow] = useState<any | null>(null);

  const openScheduleModal = (workflow: any) => {
    setSelectedWorkflow({
      id: workflow.id,
      sourceName: workflow.name,
      scheduleType: 'Manual', // Default, or fetch from backend if stored
      isActive: true,
    });
    setShowScheduleModal(true);
  };

  const [showLogsModal, setShowLogsModal] = useState(false);
  const [activeLogs, setActiveLogs] = useState<{ workflowId: string; name: string } | null>(null);

  const openLogs = (wf: any) => {
    setActiveLogs({ workflowId: wf.id, name: wf.name });
    setShowLogsModal(true);
  };


  return (
    <div>
      {/* Top Header */}
      <div className="flex flex-wrap justify-between items-center mb-6 gap-4">
        <div>
          <h2 className="text-xl font-semibold text-white">Workflows</h2>
          <p className="text-sm text-gray-400">Manage automation flows with LLMs and event triggers</p>
        </div>

        <div className="flex items-center gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="Search by name..."
              value={nameFilter}
              onChange={(e) => setNameFilter(e.target.value)}
              className="pl-10 pr-4 py-2 bg-neutral-800 border border-neutral-700 text-sm text-white rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500"
            />
            <svg
              className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 103 10.5a7.5 7.5 0 0013.15 6.15z" />
            </svg>
          </div>

          <button onClick={NavigateToBuilder} className="flex items-center bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md text-sm shadow">
            <Plus className="w-4 h-4 mr-1" /> Start New Workflow
          </button>
        </div>
      </div>

      {/* Workflow Summary */}
      <div className="mb-4 text-sm text-gray-400">
        <span className="mr-4">Running: <strong className="text-green-400">1</strong></span>
        <span className="mr-4">Stopped: <strong className="text-red-400">1</strong></span>
        <span>Total: <strong className="text-indigo-400">{filtered.length}</strong></span>
      </div>

      {/* Workflow Table */}
      <div className="overflow-x-auto rounded border border-neutral-800">
        <table className="min-w-full text-sm text-left text-gray-300">
          <thead className="bg-neutral-900 text-gray-400 sticky top-0">
            <tr>
              <th className="px-4 py-2">Name</th>
              <th className="px-4 py-2">Status</th>
              <th className="px-4 py-2">LLM</th>
              <th className="px-4 py-2">Trigger</th>
              <th className="px-4 py-2">Created By</th>
              <th className="px-4 py-2">Created On</th>
              <th className="px-4 py-2 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((wf) => (
              <tr key={wf.id} className="border-t border-neutral-800 hover:bg-neutral-800/30">
                <td className="px-4 py-3">{wf.name}</td>
                <td className="px-4 py-3">
                  <span
                    className={`inline-block px-2 py-1 rounded text-xs font-medium ${wf.status === 'Running'
                      ? 'bg-green-700 text-green-100'
                      : 'bg-red-700 text-red-100'
                      }`}
                  >
                    {wf.status}
                  </span>
                </td>
                <td className="px-4 py-3">{wf.llm}</td>
                <td className="px-4 py-3">{wf.trigger}</td>
                <td className="px-4 py-3">{wf.createdBy}</td>
                <td className="px-4 py-3 font-mono text-xs">{wf.createdOn}</td>
                <td className="px-4 py-3 flex justify-end gap-2">
                  <button onClick={() => openScheduleModal(wf)} className="text-green-400 hover:text-white" title="Schedule">
                    <CalendarDays className="w-4 h-4" />
                  </button>
                  <button onClick={() => openLogs(wf)} className="text-blue-400 hover:text-white" title="Logs">
                    <ListChecks className="w-4 h-4" />
                  </button>

                  <button onClick={() => NavigateToBuilder()} className="text-indigo-400 hover:text-white" title="View">
                    <Eye className="w-4 h-4" />
                  </button>
                  <button className="text-yellow-400 hover:text-white" title="Run">
                    <PlayCircle className="w-4 h-4" />
                  </button>
                  <button className="text-red-400 hover:text-red-200" title="Stop">
                    <StopCircle className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showScheduleModal && selectedWorkflow && (
        <EditScheduleModal
          prefill={selectedWorkflow}
          onClose={() => setShowScheduleModal(false)}
          onSubmit={(updated) => {
            console.log('Schedule updated:', updated);
            // 🔁 Optionally call API here to save changes
          }}
        />
      )}

      {showLogsModal && activeLogs && (
        <LogsModal
          workflowId={activeLogs.workflowId}
          name={activeLogs.name}
          onClose={() => setShowLogsModal(false)}
        />
      )}


    </div>
  );
};

export default Workflows;
